import React, { FC, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';

import { createAuthQuery } from 'app/modules/SigningNew/utils/auth-modals-query';

import { AuthContext } from '../../context';
import { Authorization } from '../Authorization';
import { Header } from '../Header';
import { Signing } from '../Signing/Signing';

import styles from './SignModal.module.scss';

export const SignContent: FC = () => {
  const { authData } = useContext(AuthContext);
  const { search } = useLocation();
  const isSign = search.startsWith(createAuthQuery('sign'));
  const isLoginTab = search.startsWith(createAuthQuery('login'));

  const { shake } = authData;

  const contentClassnames = classNames(styles.loginModalContent, {
    [styles.shake]: shake,
  });

  return (
    <div className={contentClassnames}>
      <Header />

      {isLoginTab && (
        <Authorization />
      )}

      {isSign && (
        <Signing />
      )}
    </div>
  );
};
